'use strict';

// *************************
//  Import assets

const iconHamburger = new URL('../img/icon-hamburger.svg', import.meta.url);
const iconClose = new URL('../img/icon-close.svg', import.meta.url);

console.log(iconHamburger, iconClose);

// *************************
//  Selectors

const navBtn = document.querySelector('#nav-btn');
const navBtnIcon = navBtn.querySelector('img');
const navMenu = document.querySelector('#nav-menu');

// *************************
//  State

let isNavOpen = false;

// *************************
//  Functions

const toggleNav = function () {
  isNavOpen = !isNavOpen;

  if (isNavOpen) {
    // Update button icon
    navBtnIcon.src = iconClose;

    // Disable background scrolling
    document.body.classList.add('has-overlay');
  } else {
    // Update button icon
    navBtnIcon.src = iconHamburger;

    // Enable background scrolling
    document.body.classList.remove('has-overlay');
  }

  navMenu.classList.toggle('navigation__menu--open');
};

// *************************
//  Event Listeners

navBtn.addEventListener('click', toggleNav);
